import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";

import { GET_USER_ACTIVITIES } from "../../Action/actionTypes";

import { getActivitiesDataDataFailure, getActivitiesDataDataSuccess } from "../../Action";


function* getUserActivityRequest(action) {
    try {
        const userID = action?.payload?.payload
        const { data } = yield API.get(`/activities?userId=${userID}`);

        if (data?.code === 200) {
            yield put(getActivitiesDataDataSuccess(data?.data));

            if (action?.payload?.callback) {
                yield call(action.payload.callback, data);
            }
        } else {
            yield put(getActivitiesDataDataFailure());
           
        }
    } catch (error) {
        yield put(getActivitiesDataDataFailure());
       
    }
}

export function* watchGetUserActivityAPI() {
    yield takeEvery(GET_USER_ACTIVITIES, getUserActivityRequest);
}

export default function* rootSaga() {
    yield all([watchGetUserActivityAPI()]);
}
